import { attributionFromSearch, type Attribution } from '../domain/attribution';
import { newJourneyId } from '../domain/ids';

export type Journey = { journeyId: string; attribution: Attribution };

const KEY = 'fh.journey.v1';

/**
 * The journey starts at first entry. It lives only in this tab's session storage
 * and reaches the server only with a completed submission (decision D2).
 */
export function currentJourney(): Journey {
  try {
    const stored = sessionStorage.getItem(KEY);
    if (stored) return JSON.parse(stored) as Journey;
  } catch {
    /* storage unavailable: fall through to an in-memory journey */
  }
  const journey = { journeyId: newJourneyId(), attribution: attributionFromSearch(window.location.search, new Date()) };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(journey));
  } catch {
    /* ignore */
  }
  return journey;
}

export function loadState<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveState(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function clearState(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
